import { Component, OnInit } from "@angular/core";
import { ReportTableComponent } from "../reporttable.component";

import { AlertService } from "../../util/alert/alert.service";
import { SharedService } from "../../home/shared.service";
import { ReportService } from "../report.service";
import { Report } from "../report.model";

@Component({
	selector: "app-never-assessed-report",
	templateUrl: "./neverassessed.component.html"
})
export class NeverAssessedReportComponent extends ReportTableComponent
	implements OnInit {
	public report: Report;
	public excelData: any[];
	public columns: Array<any> = [
		{
			title: "First Name",
			name: "First Name",
			filtering: { filterString: "" }
		},
		{
			title: "Last Name",
			name: "Last Name",
			filtering: { filterString: "" }
		},
		{
			title: "Contractor",
			name: "Contractor",
			filtering: { filterString: "" }
		},
		{
			title: "Email",
			name: "Email",
			filtering: { filterString: "" }
		},
		{
			title: "Org Code",
			name: "Org Code",
			filtering: { filterString: "" }
		},
		{
			title: "Supervisor Name",
			name: "Supervisor Name",
			filtering: { filterString: "" }
		},
		{
			title: "Job Profile",
			name: "Job Profile",
			filtering: { filterString: "" }
		}
	];

	private serverResultData: Array<any> = [];

	config: any = {
		paging: true,
		sorting: { columns: this.columns },
		filtering: { filterString: "" },
		className: ["table-striped", "table-bordered"]
	};

	constructor(
		private alertService: AlertService,
		private sharedService: SharedService,
		private reportService: ReportService
	) {
		super();
		this.report = this.reportService.getSelectedReport();
	}

	ngOnInit() {
		this.loadNeverAssessedCandidates(this.report.reportData);
	}

	loadNeverAssessedCandidates(data: any) {
		this.excelData = [];
		for (let i = 0; i < data.length; i++) {
			this.data.push({
				"First Name": data[i].FirstName,
				"Last Name": data[i].LastName,
				"Contractor": data[i].IsContract == 0 ? "No" : "Yes",
				"Email": data[i].Email,
				"Org Code": data[i].OrgCode == null ? "" : data[i].OrgCode,
				"Supervisor Name":
				data[i].SupervisorName == null
					? ""
					: data[i].SupervisorName,
				"Job Profile": data[i].JobProfile == null ? "" : data[i].JobProfile
			});

			// this.excelData.push({
			//   "First Name": data[i].FirstName,
			//   "Last Name": data[i].LastName,
			//   "Email": data[i].Email,
			//   "Org Code": data[i].OrgCode == null ? "" : data[i].OrgCode,
			//   "Supervisor Name":
			//     data[i].SupFirstName == null
			//       ? ""
			//       : data[i].SupFirstName + " " + data[i].SupLastName,
			//   "Job Profile": data[i].JobProfile == null ? "" : data[i].JobProfile
			// });
		}
		this.serverResultData = this.data;
		//  this.report.reportDataList = this.excelData;
		this.report.columns = this.columns;
		this.config.report = this.report;
		this.pageCount = Math.ceil(
			this.serverResultData.length / this.itemsPerPage
		);
		//	console.log(JSON.stringify(this.serverResultData));
		this.onChangeTable(this.config);
	}
}
